<template>
  <md-card>
    <md-card-header>
      <h3>Datos fiscales</h3>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('wayToPay')">
            <label>Forma de pago</label>
            <md-input
              type="number"
              data-vv-name="wayToPay"
              v-validate="modelValidations.wayToPay"
              v-model="fiscalData.wayToPay"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100"></div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('paymentMethod')">
            <label>Método de pago</label>
            <md-input
              data-vv-name="paymentMethod"
              v-validate="modelValidations.paymentMethod"
              v-model="fiscalData.paymentMethod"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('bussinessName')">
            <label>Nombre comercial</label>
            <md-input
              data-vv-name="bussinessName"
              v-validate="modelValidations.bussinessName"
              v-model="fiscalData.bussinessName"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('rfc')">
            <label>RFC</label>
            <md-input
              data-vv-name="rfc"
              v-validate="modelValidations.rfc"
              v-model="fiscalData.rfc"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('account')">
            <label>Cuenta</label>
            <md-input
              data-vv-name="account"
              v-validate="modelValidations.account"
              v-model="fiscalData.account"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('clabe')">
            <label>CLABE</label>
            <md-input
              data-vv-name="clabe"
              v-validate="modelValidations.clabe"
              v-model="fiscalData.clabe"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="validationClass('bank')">
            <label>Banco</label>
            <md-select
              data-vv-name="bank"
              v-validate="modelValidations.bank"
              v-model="fiscalData.bank"
            >
              <md-option
                v-for="item in banks"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</md-option
              >
            </md-select>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <contact-address
          @setAsentamiento="(v) => $emit('setAsentamiento', v)"
          isFiscalData
          :address="fiscalData.fiscalAddress"
        ></contact-address>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import ContactAddress from './Address'
import usesParentValidatorMixin from '@/mixins/usesParentValidator'

const modelValidations = {
  wayToPay: {
    required: true
  },
  paymentMethod: {
  },
  bussinessName: {
    required: true
  },
  bank: {
    required: false
  },
  account: {

  },
  rfc: {

  },
  clabe: {
    min: 16,
    max: 18
  }
}

export default {

  name: 'FiscalData',

  mixins: [usesParentValidatorMixin],

  components: {
    ContactAddress
  },

  props: {
    fiscalData: {
      type: Object,
      default: () => { return {} }
    },
    banks: {
      type: Array,
      default: () => []
    }
  },


  mounted() {
    this.watchTouched({ fiscalData: Object.keys(modelValidations) })
  },
  data() {
    return {
      modelValidations
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Forms/FiscalData.vue